import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  consentContainer: { padding: 20, gap: 16 },

  divider: {
    width: '100%',
    height: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },

  consentTypeLabel: {
    fontWeight: 700,
    fontSize: 14,
    color: colors.newUI.therapist.grey70,
  },

  unrevokableConsentLabel: {
    fontWeight: 600,
    color: colors.newUI.therapist.red70,
  },
  consentTitle: { fontWeight: 600 },

  expandableSectionTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },

  expandableSectionText: {
    fontWeight: 600,
    color: colors.newUI.therapist.primaryBlue80,
  },
});
